import loadModuleOnElement from "../../utils/loadModuleOnElement";

const loader = () => import("./renderer");
const selector = ".like-button";

export default function loadFollowButton(context) {
    loadModuleOnElement(selector, loader, context);
    return context;
}
